var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_4051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4529 0C18.396 0 0.452881 17.9431 0.452881 40C0.452881 62.0569 18.396 80 40.4529 80C62.5098 80 80.4529 62.0569 80.4529 40C80.4529 17.9431 62.5098 0 40.4529 0Z",
    fill: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7263 31.5234L39.0594 53.1897C38.4094 53.8397 37.5562 54.1669 36.7029 54.1669C35.8496 54.1669 34.9963 53.8397 34.3463 53.1897L23.5132 42.3566C22.2095 41.0535 22.2095 38.9465 23.5132 37.6434C24.8163 36.3397 26.9226 36.3397 28.2263 37.6434L36.7029 46.12L56.0132 26.8103C57.3163 25.5066 59.4226 25.5066 60.7263 26.8103C62.0294 28.1134 62.0294 30.2197 60.7263 31.5234Z",
    fill: "#0B0D0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_4051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.452881)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheck);
export default __webpack_public_path__ + "static/media/white-check.249408b0a23b5c5831925c6f08e39826.svg";
export { ForwardRef as ReactComponent };